import { render, staticRenderFns } from "./PromoDetailModal.vue?vue&type=template&id=43aad91d"
import script from "./PromoDetailModal.vue?vue&type=script&lang=ts"
export * from "./PromoDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PromoDetailModal.vue?vue&type=style&index=0&id=43aad91d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports